export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9159.5b2a06ed.jpg";